import React from 'react';
import { Link, useStaticQuery, graphql } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faMap,
  faMapMarkerAlt,
  faClock,
  faCubes,
  faFileInvoice,
  faEuroSign,
  faTasks,
  faTree,
  faPowerOff,
  faThumbsUp,
  faWrench,
  faHandshake,
} from '@fortawesome/free-solid-svg-icons';
import isEmpty from 'lodash/isEmpty';

import Layout from '../components/Layout';
import ImageServices from '../components/ImageServices';
import SafeMarkdown from '../components/SafeMarkdown';
import SafeGatsbyImage from '../components/SafeGatsbyImage';
import SafeBackgroundImage from '../components/SafeBackgroundImage';

import { handleData } from '../lib/dataHelper';

// import '../styles/less/global-style.less';

const homePage = ({ data }) => {
  const dataToUse = handleData(data) || {};
  const {
    title,
    baseline,
    postalAddress,
    schedules,
    longCurriculum,
    perimeter,
    photo_presentation = {},
    du_cote_de_chez_perge = {},
    backgroundLocalFile = {},
  } = dataToUse;

  const testimonials = data.allStrapiTemoignages?.nodes || [];
  const news = data.allStrapiActualites?.nodes || [];
  const { titleSelfPromotion, contentSelfPromotion, image: imageSP = {} } = du_cote_de_chez_perge;
  // const news = [];

  return (
    <Layout data={dataToUse}>
      <SafeBackgroundImage image={backgroundLocalFile} className="slice bg-banner-1 bannerMain" />

      <section className="slice bg-3 entreprise">
        <div className="w-section inverse">
          <div className="container">
            <div className="row">
              <div className="col-md-3">
                <SafeGatsbyImage itemProp="image" image={photo_presentation} />
              </div>
              <div className="col-md-9">
                <h2 className="section-title">{title}</h2>
                <h3>{baseline}</h3>
                <SafeMarkdown>{longCurriculum}</SafeMarkdown>

                <div className="row">
                  <div className="col-md-4 col-sm-12 entreprise-details">
                    <div className="w-box white">
                      <div className="thmb-img">
                        <FontAwesomeIcon className="fa" icon={faMapMarkerAlt} />
                      </div>
                      <h3>Coordonnées</h3>
                      <SafeMarkdown itemProp="address" className="text-center">
                        {postalAddress}
                      </SafeMarkdown>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12 entreprise-details">
                    <div className="w-box white">
                      <div className="thmb-img">
                        <FontAwesomeIcon className="fa" icon={faMap} />
                      </div>
                      <h3>Périmètre d'interventions</h3>
                      <p itemProp="areaServed" className="text-center">
                        {perimeter}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12 entreprise-details">
                    <div className="w-box white">
                      <div className="thmb-img">
                        <FontAwesomeIcon className="fa" icon={faClock} />
                      </div>
                      <h3>Horaires</h3>
                      <SafeMarkdown
                        itemProp="openingHours"
                        content="Mo-Fr 08:00-12:00,14:00-17:00"
                        className="text-center"
                      >
                        {schedules}
                      </SafeMarkdown>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="box-element box-element-outer">
              <div className="row">
                <div className="col-md-12">
                  <Link className="btn btn-two btn-lg pull-right" title="Nous contacter" to="/nous-contacter/">
                    Nous contacter
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="slice box-element bg-2 animate-hover-slide cta hierarchy accesRapide">
        <div className="container">
          <div className="row">
            <div className="col-md-4 col-sm-12 accesRapideItem">
              <div className="w-box white">
                <a href="https://www.perge.com/fr-fr/produits/" title="Nos produits">
                  <div className="thmb-img">
                    <FontAwesomeIcon className="fa" icon={faCubes} />
                  </div>
                  <h2>Nos produits</h2>
                </a>
                <p className="text-center">
                  français, simples et robustes, respectueux de l'environnement.  Biomasse, bois et granulés,
                  compatibles Bio Fioul, certifiées Eco Conception, Pompe à chaleurs hybrides, combinés solaire.
                </p>
              </div>
            </div>
            <div className="col-md-4 col-sm-12 accesRapideItem">
              <div className="w-box white">
                <a href="https://www.perge.com/fr-fr/aides-financieres" title="Aides financières">
                  <div className="thmb-img">
                    <FontAwesomeIcon className="fa" icon={faEuroSign} />
                  </div>
                  <h2>Aides financières</h2>
                </a>
                <p className="text-center">
                  pour la précarité énergétique et pour la rénovation dans le cadre de la transition écologique.
                </p>
              </div>
            </div>
            <div className="col-md-4 col-sm-12 accesRapideItem">
              <div className="w-box white">
                <a href="/nous-contacter" title="Pièces &amp; notices">
                  <div className="thmb-img">
                    <FontAwesomeIcon className="fa" icon={faFileInvoice} />
                  </div>
                  <h2>Devis gratuit</h2>
                </a>
                <p className="text-center"></p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="slice bg-1 services hierarchy">
        <div className="w-section inverse">
          <div className="container">
            <h2 className="section-title">Nos services</h2>
            <h3 className="subtitle">proximité, environnement et robustesse</h3>
            <div className="row">
              <div className="col-md-9">
                <div className="row">
                  <div className="col-md-6">
                    <div className="aside-feature">
                      <div className="row">
                        <div className="col-md-3">
                          <div className="icon-feature">
                            <FontAwesomeIcon className="fa" icon={faTasks} />
                          </div>
                        </div>
                        <div className="col-md-9">
                          <h3>Conseils en rénovation de chauffage</h3>
                          <p className="description">
                            comment réduire sa facture énergétique, quelle énergie choisir, à quelles aides ai-je droit
                            en toute confiance , comment viser une forme d'autonomie tout en gardant de la commodité,
                            comment choisir un produit durable et robuste&nbsp;?
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="aside-feature">
                      <div className="row">
                        <div className="col-md-3">
                          <div className="icon-feature">
                            <FontAwesomeIcon className="fa" icon={faTree} />
                          </div>
                        </div>
                        <div className="col-md-9">
                          <h3>Transition écologique et respect de l’environnement</h3>
                          <p className="description">
                            le choix de produits d'un constructeur français, avec des produits simples et robustes,
                            respectueux de environnement, à haute performance énergétique, éligibles aux aides proposées
                            par l’État dans le cadre de l'aide à la précarité énergétique et la la rénovation
                            énergétique
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="aside-feature">
                      <div className="row">
                        <div className="col-md-3">
                          <div className="icon-feature">
                            <FontAwesomeIcon className="fa" icon={faPowerOff} />
                          </div>
                        </div>
                        <div className="col-md-9">
                          <h3>Installation et mise en service</h3>
                          <p className="description">
                            la sécurité d'un service local, la possibilité d'extension de garantie jusqu’à 10 ans,
                            gratuite.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="aside-feature">
                      <div className="row">
                        <div className="col-md-3">
                          <div className="icon-feature">
                            <FontAwesomeIcon className="fa" icon={faThumbsUp} />
                          </div>
                        </div>
                        <div className="col-md-9">
                          <h3>Réparabilité des produits proposés</h3>
                          <p className="description">
                            des produits essentiellement fabriqués en France, robustes et durables, sélectionnés pour
                            leur taux de fiabilité et leur critère de réparabilité élevé.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="aside-feature">
                      <div className="row">
                        <div className="col-md-3">
                          <div className="icon-feature">
                            <FontAwesomeIcon className="fa" icon={faWrench} />
                          </div>
                        </div>
                        <div className="col-md-9">
                          <h3>Dépannage</h3>
                          <p className="description">
                            disponibilité et professionnalisme d'un chauffagiste proche de chez vous 6 /7j.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="aside-feature">
                      <div className="row">
                        <div className="col-md-3">
                          <div className="icon-feature">
                            <FontAwesomeIcon className="fa" icon={faHandshake} />
                          </div>
                        </div>
                        <div className="col-md-9">
                          <h3>Entretien et maintenance</h3>
                          <p className="description">
                            un professionnel de proximité à votre service, avec des intervenants techniciens
                            chauffagistes.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="aside-feature">
                      <div className="row">
                        <div className="col-md-3">
                          <div className="icon-feature">
                            <FontAwesomeIcon className="fa" icon={faFileInvoice} />
                          </div>
                        </div>
                        <div className="col-md-9">
                          <h3>Devis gratuit</h3>
                          <p className="description">
                            visite technique et devis adapté à votre demande et à vos besoins.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <ImageServices />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      {testimonials.length && (
        <section className="slice bg-5 temoignage">
          <div className="w-section inverse">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="text-center">
                    <h2 className="section-title">Ce que disent nos clients</h2>

                    <div className="row">
                      {testimonials.map(({ commentaire, auteur, strapiId }) => (
                        <div key={strapiId} className={testimonials.length > 1 ? 'col-md-6' : 'col-md-12'}>
                          <div className="testimonial-text">
                            <p itemProp="review">{commentaire}</p>
                            <p className="testimonial-author">{auteur}</p>
                          </div>
                        </div>
                      ))}
                    </div>

                    <span className="clearfix"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      <section className="slice box-element bg-2 animate-hover-slide cta hierarchy">
        <div className="container">
          <div className="row">
            <div className="col-md-9">
              <h2>Vous avez un projet d'installation ?</h2>
            </div>
            <div className="col-md-3">
              <Link className="btn btn-one btn-lg pull-right" title="Contactez-nous !" to="/nous-contacter/">
                Contactez-nous !
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="slice bg-3">
        <div className="w-section inverse">
          <div className="container">
            <div className="row produitEntete">
              {/* NEWS */}
              {(news.length && (
                <div className="col-md-6">
                  <h2 className="section-title">Actualités</h2>
                  <h3>{news[0].titre}</h3>
                  <div className="produitCaracteristique">
                    <SafeMarkdown>{news[0].contenu}</SafeMarkdown>
                  </div>
                </div>
              )) ||
                null}

              {/* SELF-PROMOTIONS */}
              {!isEmpty(du_cote_de_chez_perge) && (
                <div className={news.length ? 'col-md-6' : 'col-md-12'}>
                  <h2 className="section-title">Du côté de chez Perge</h2>
                  <div className="row">
                    <div className="col-md-4">
                      <SafeGatsbyImage image={imageSP} />
                    </div>
                    <div className="col-md-8">
                      <h3>{titleSelfPromotion}</h3>
                      <div className="produitCaracteristique">
                        <SafeMarkdown>{contentSelfPromotion}</SafeMarkdown>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export const query = graphql`
  query HomePageQuery($partenaireId: Int!, $today: Date!) {
    staticMap {
      ...Map
    }
    strapiPartenaires(strapiId: { eq: $partenaireId }) {
      title: Nom
      email
      baseline
      seoDescription: description_seo
      longCurriculum: description_longue
      perimeter: perimetre_intervention
      url_mini_site
      photo_presentation {
        alternativeText
        localFile {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH)
          }
        }
      }
      ...Contact
      ...Logo
      ...Header
      ...Footer
      ...SelfPromotions
    }
    allStrapiTemoignages(
      filter: { partenaire: { id: { eq: $partenaireId } } }
      limit: 2
      sort: { fields: updated_at, order: DESC }
    ) {
      nodes {
        strapiId
        commentaire
        auteur
      }
    }
    backgroundLocalFile: file(relativePath: { eq: "Fond_blanc_mini-site.jpg" }) {
      childImageSharp {
        gatsbyImageData
        fluid(maxWidth: 1920, jpegQuality: 90, webpQuality: 90) {
          srcSetWebp
          srcWebp
        }
      }
    }
    allStrapiActualites(
      filter: {
        partenaire: { id: { in: [$partenaireId, null] } }
        date_publication: { lte: $today }
        date_depublication: { gte: $today }
      }
      limit: 1
      sort: { fields: partenaire___id, order: ASC }
    ) {
      nodes {
        titre
        contenu
      }
    }
  }
`;

export default homePage;
